import IconButton from '@mui/material/IconButton';
import type { SxProps, Theme } from '@mui/material/styles';

import { AddItemIcon } from '@/assets/icons/AddItemIcon';
import { mergeSx } from '@/utils/mergeSx';

import { addFormFieldStyles as sx } from './AddFormFieldButton.styles';

type Props = {
	onClick: () => void;
	customSx?: SxProps<Theme>;
};

export const AddFormFieldButton = ({ onClick, customSx }: Props) => {
	return (
		<IconButton
			disableRipple
			size='small'
			aria-label='Remove field'
			onClick={onClick}
			sx={mergeSx(sx.add, customSx)}
		>
			<AddItemIcon sx={sx.icon} />
		</IconButton>
	);
};
